export default __webpack_public_path__ + "static/media/home-img4.79c92eb5.svg";